import { MessagesType } from '@telialt/common-cms/src/model';
import { PreparedVariation, ProductVariantAlias } from '@telialt/models/src/EshopModel';

export const getVariationTitle = (variation: PreparedVariation, t: MessagesType) => {
    const alias = variation?.alias;

    const titleByAliasMap: Record<ProductVariantAlias, string> = {
        COLOR: t['eshop.product_page.color.selector.title'],
        SIZE: t['eshop.product_page.storage.selector.title'],
        DIAGONAL: t['eshop.product_page.screen_diagonal.selector.title'],
        SCREEN_SIZE: t['eshop.product_page.screen_size.selector.title'],
        SCREEN_SIZE_IN: t['eshop.product_page.screen_size_in.selector.title'],
        SCREEN_SIZE_MM: t['eshop.product_page.screen_size_mm.selector.title'],
        BAND_SIZE: t['eshop.product_page.band_size.selector.title'],
        RING_SIZE: t['eshop.product_page.ring_size.selector.title'],
        RAM_CAPACITY: t['eshop.product_page.ram_capacity.selector.title'],
        INTERNET_CONNECTION: t['eshop.product_page.internet_connection.selector.title'],
    };
    const title = titleByAliasMap[alias];

    return title;
};
